import React from "react";
import {CustomLink} from "../../../links";
import './NotificationLink.scoped.scss';
import {RouteDictionary} from "../../../../../utils";
import notifications from "assets/images/svg/notification.svg";
import {Image} from "../../../images";

const NotificationLink = () => {
  return (
    <CustomLink to={RouteDictionary.NOTIFICATIONS} className="notifications-link">
      <Image src={notifications} alt={'notifications'}/>
    </CustomLink>
  );
};

export default NotificationLink;